import { render, staticRenderFns } from "./veJkyProjectBase.vue?vue&type=template&id=2a988be2&scoped=true"
import script from "./veJkyProjectBase.vue?vue&type=script&lang=js"
export * from "./veJkyProjectBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a988be2",
  null
  
)

export default component.exports